/**
 * @flow
 */
import { Box, SvgIcon, Typography } from '@mui/material';
import QuestionForm from 'components/@home/drawers/FillFormDrawer/QuestionForm';
import ArrowRightIcon from 'mdi-react/ArrowRightIcon';
import React, { useRef } from 'react';
import { Transition } from 'react-transition-group';

const transitionBaseSx = {
  overflow: 'hidden',
  width: '100%',
  transition: 'opacity 300ms, transform 300ms',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
};

const getTransitionSx = state => {
  switch (state) {
    case 'exited':
      return {
        ...transitionBaseSx,
        transition: 'none',
        display: 'none',
        opacity: 0,
        transform: 'translateY(100%)',
      };
    case 'entered':
      return {
        ...transitionBaseSx,
        opacity: 1,
        transform: 'translateY(0%)',
      };
    case 'exiting':
      return {
        ...transitionBaseSx,
        position: 'absolute',
        opacity: 0,
        transform: 'translateY(-100%)',
      };
    case 'entering':
      return {
        ...transitionBaseSx,
        opacity: 1,
        transform: 'translateY(100%)',
      };
    default:
      return transitionBaseSx;
  }
};

type Props = {
  form: Object,
};

const QuestionSlide = ({ question, index, currentQuestion }) => {
  const nodeRef = useRef(null);
  return (
    <Transition timeout={300} nodeRef={nodeRef} in={index === currentQuestion}>
      {state => (
        <Box ref={nodeRef} sx={getTransitionSx(state)}>
          <Box
            sx={theme => ({
              mt: theme.spacing(4),
              mb: theme.spacing(4),
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            })}
          >
            <Box
              sx={theme => ({
                mb: theme.spacing(3),
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              })}
            >
              <Box
                sx={theme => ({
                  display: 'flex',
                  flexDirection: 'row',
                  width: theme.spacing(4),
                  textAlign: 'right',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                })}
              >
                <Typography color="primary">{index + 1}</Typography>
                <SvgIcon
                  sx={theme => ({
                    fontSize: 16,
                    color: theme.palette.primary.dark,
                  })}
                >
                  <ArrowRightIcon />
                </SvgIcon>
              </Box>
              <Typography variant="h6" component="h6" sx={theme => ({ ml: theme.spacing(1) })}>
                {question.title}
              </Typography>
            </Box>
            <Box
              sx={theme => ({
                ml: theme.spacing(5),
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
              })}
            >
              <QuestionForm question={question} />
            </Box>
          </Box>
        </Box>
      )}
    </Transition>
  );
};

const FillFormDrawerQuestions = ({
  form: {
    values: { form, currentQuestion },
  },
}: Props) => {
  if (!form.questions) {
    return null;
  }
  return (
    <>
      {form.questions.map((question, index) => (
        <QuestionSlide
          key={question._id}
          question={question}
          index={index}
          currentQuestion={currentQuestion}
        />
      ))}
    </>
  );
};

export default FillFormDrawerQuestions;
